import { createStore } from 'vuex'

export default createStore({
    state: {
        server:
        {
            pendingRequests: []
        },
    },
    mutations: {
        setServer(state, payload) {
            state.server = payload
        },
    },
    actions: {
        addPendingRequest({ commit, state }, request) {
            state.server.pendingRequests.push(request)
            commit('setServer', state.server)
        },

        removePendingRequest({ commit, state }, request) {
            state.server.pendingRequests =
                state.server.pendingRequests.filter(x => x.url !== request.url);
            commit('setServer', state.server)
        },
    },
    modules: {
    }
})
